import { useContext } from 'react';
import { SearchContext } from '../contexts/SearchContext';

// A custom hook allows us to test better.
export const useSearchContext = () => useContext(SearchContext);

export default useSearchContext;
